import Vue from 'vue'
import VueRouter from 'vue-router'
import iView from 'iview';
import Util from '../libs/util';
import Cookies from 'js-cookie';
import PageName from '../constant/PageName';
import * as Cache from '../cache/Cache';

import {routers, otherRouter, appRouter} from './router'

Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  routes: routers
})

router.beforeEach((to, from, next) => {
  let name = to.name;
  if(to.name == PageName.PAGE_EXPERT_APPLICATION) {
    //专家申请
    name += "," + to.query.categoryId;
  }
  router.app.$store.commit('setCurrentPageName', name);

  iView.LoadingBar.start();
  Util.title(to.meta.title);
  if (Cookies.get('locking') === '1' && to.name !== PageName.PAGE_LOCKING) { // 判断当前是否是锁定状态
    next({
      replace: true,
      name: 'locking'
    });
  } else if (Cookies.get('locking') === '0' && to.name === PageName.PAGE_LOCKING) {
    next(false);
  } else {
    let userInfo = Cache.getUserInfo();
    if (!userInfo && to.name !== PageName.PAGE_LOGIN && to.name !== PageName.PAGE_REGISTER && to.name !== PageName.PAGE_FORGET_PASSWORD) { // 判断是否已经登录且前往的页面不是登录页
      next({
        name: 'login'
      });
    } else if (userInfo && (to.name === PageName.PAGE_LOGIN || to.name === PageName.PAGE_REGISTER || to.name === PageName.PAGE_FORGET_PASSWORD)) { // 判断是否已经登录且前往的是登录页
      Util.title();
      next({
        name: PageName.PAGE_HOME_INDEX
      });
    } else {
      //路由权限配置
      let permissionsInfo = Cache.getPermissions();
      let permissions = permissionsInfo ? permissionsInfo : [];
      const router = Util.getRouterObjByName([otherRouter, ...appRouter], to.name);
      if (router && router.permissionId) { // 需要判断权限的路由
        if (Util.isHavePermission(router.permissionId, permissions)) {
          Util.toDefaultPage([otherRouter, ...appRouter], to.name, router, next); // 如果在地址栏输入的是一级菜单则默认打开其第一个二级菜单的页面
        } else {
          next({
            replace: true,
            name: 'error-403'
          });
        }
      } else { // 没有配置权限的路由, 直接通过
        Util.toDefaultPage([...routers], to.name, router, next);
      }
    }
  }
});

router.afterEach((to) => {
  // Util.openNewPage(router.app, to.name, to.params, to.query);
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js